import { LanguageProficiency } from '@aibees/elephant/feature/search-table-people';
import { Nullable } from '@aibees/shared/definition';
import { capitalize } from '@aibees/shared/utils';

export function humanReadableLanguageProficiency(
  proficiency: Nullable<LanguageProficiency>
) {
  if (!proficiency) return '';
  return capitalize(proficiency.replaceAll('_', ' '));
}
